import Shimmer from "./Shimmer";

const SkeletonField = ({ width = "w-full" }: { width?: string }) => (
  <div className="space-y-2">
    <Shimmer className="h-3 w-20" />
    <Shimmer className={`h-5 ${width}`} />
  </div>
);

const ActivityCardSkeleton = () => (
  <div className="rounded-xl border border-white/5 bg-[#17171F] p-5 space-y-4">
    <div className="flex items-center gap-3">
      <Shimmer className="h-10 w-10 rounded-lg" />

      <div className="flex-1 space-y-2">
        <Shimmer className="h-5 w-1/2" />
        <Shimmer className="h-4 w-3/4" />
      </div>

      <Shimmer className="h-6 w-16 rounded-full" />
    </div>

    <Shimmer className="h-4 w-full" />
    <Shimmer className="h-4 w-5/6" />
  </div>
);

const ContactDetailsSkeleton = () => {
  return (
    <div className="flex h-full bg-[#111119] text-white">
      {/* Left Sidebar */}
      <aside className="w-[280px] border-r border-white/5 p-5 space-y-5">
        {/* Profile */}
        <div className="flex items-center gap-4">
          <Shimmer className="h-14 w-14 rounded-full" />

          <div className="flex-1 space-y-2">
            <Shimmer className="h-5 w-32" />
            <Shimmer className="h-4 w-40" />
          </div>
        </div>

        {/* Contact Details */}
        <div className="rounded-xl border border-white/5 p-4 space-y-4">
          <SkeletonField />
          <SkeletonField />
          <SkeletonField />
          <SkeletonField width="w-3/4" />
        </div>

        {/* Owner */}
        <div className="rounded-xl border border-white/5 p-4">
          <div className="flex items-center gap-3">
            <Shimmer className="h-10 w-10 rounded-full" />
            <Shimmer className="h-5 flex-1" />
          </div>
        </div>
      </aside>

      {/* Center */}
      <main className="flex-1 p-6 space-y-6">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex gap-3">
            <Shimmer className="h-10 w-28 rounded-lg" />
            <Shimmer className="h-10 w-32 rounded-lg" />
          </div>

          <Shimmer className="h-10 w-52 rounded-lg" />
        </div>

        {/* Tabs */}
        <div className="flex gap-8">
          <Shimmer className="h-5 w-20" />
          <Shimmer className="h-5 w-16" />
          <Shimmer className="h-5 w-16" />
        </div>

        {/* Activity */}
        <div className="space-y-4">
          <ActivityCardSkeleton />
          <ActivityCardSkeleton />
          <ActivityCardSkeleton />
        </div>
      </main>

      {/* Right Sidebar */}
      <aside className="w-[300px] border-l border-white/5 p-5 space-y-5">
        {/* Stats */}
        <div className="grid grid-cols-2 gap-3">
          {Array.from({ length: 4 }).map((_, i) => (
            <Shimmer key={i} className="h-20 rounded-xl" />
          ))}
        </div>

        {/* Related Items */}
        <div className="rounded-xl border border-white/5 p-4 space-y-4">
          <Shimmer className="h-5 w-32" />

          {Array.from({ length: 3 }).map((_, i) => (
            <Shimmer key={i} className="h-14 rounded-lg" />
          ))}
        </div>
      </aside>
    </div>
  );
};

export default ContactDetailsSkeleton;